<template>
  <a-row class="comment-item">
    <a href="#" class="comment-item__close"></a>
    <a-col
      :span="2"
      :class="
        note.createdBy === userId ? 'comment-item__float-left' : 'comment-item__float-right'
      "
      class="comment-item__header"
    >
      <!-- <a-avatar class="comment-item__header-avarta" size="large" style="background: #76cce8;">
        <img v-if="userHead" slot="icon" :src="userHead" />
      </a-avatar> -->
    </a-col>
    <a-col
      :span="22"
      :class="
        note.createdBy === userId ? 'comment-item__float-right' : 'comment-item__float-left'
      "
      style="padding-right: 10px;padding-left: 4px;"
    >
      <a-col
        :span="20"
        :class="
          note.createdBy === userId ? 'comment-item__float-left' : 'comment-item__float-right'
        "
      >
        <div><span class="comment-item__email_address">{{ note.emailAddress }}</span></div>
        <div id="message"
            :class="
              note.createdBy === userId
                ? 'comment-item__message-right'
                : 'comment-item__message-left'
            "
            class="comment-item__message">
          <div v-html="note.text"></div> 
          <!-- <div id="closeButton" class="comment-item__close-button"></div> -->
          <!-- <div
            id="message"
            :class="
              note.createdBy === userId
                ? 'comment-item__message-right'
                : 'comment-item__message-left'
            "
            class="comment-item__message"
            v-html="note.text">
          </div> -->
          <button class="btn-close" @click="deleteNote()">
            <div>X</div>
          </button>
        </div>
        <div
          class="comment-item__message-date"
          :style="note.createdBy === userId ? 'text-align: left;' : 'text-align: right;'"
        >
          {{ humanReadableDate(note.createdAt) }}
        </div>
      </a-col>
      <a-col
        :span="4"
        :class="
          note.createdBy === userId ? 'comment-item__float-right' : 'comment-item__float-left'
        "
      ></a-col>
    </a-col>
  </a-row>
</template>
<script>
export default {
  props: {
    brand: { type: Object, default: () => {} },
    retailer: { type: Object, default: () => {} },
    note: { type: Object, default: () => undefined }
  },
  data() {
    return {
      member: null,
      userHead: undefined
    }
  },
  computed: {
    userId() {
      return this.$store.getters["user/id"]
    }
  },
  watch: {
    comment(newValue) {
      if (newValue) {
        this.member = this.commentAuthor(newValue)
        this.setUserHeadUrl()
      }
    }
  },
  created() {
    if (this.comment) {
      this.member = this.commentAuthor(this.comment)
      console.log(this.member)
      this.setUserHeadUrl()
    }
  },
  methods: {
    deleteNote(){
      console.log('deleteNote....', this.note.privateId);
      this.$emit('parent-on-note-deleted', this.note.privateId);
    },
    setUserHeadUrl() {
      if (this.member && this.member.logoAsset.url) {
        this.userHead = this.member.logoAsset.url
      }
    },
    commentAuthor(item) {
      let result = {}
      let clientId = item.createdBy
      let retailerMembers = this.retailer.members || []
      let brandMembers = this.brand.members || []
      result = retailerMembers.find(member => member.user.id == clientId)
      if (result) {
        return this.retailer
      }
      result = brandMembers.find(member => member.user.id == clientId)
      if (result) {
        return this.brand
      }
      return { name: "Landing Admin", logoAsset: {} }
    },
    humanReadableDate(isoString) {

      console.log('note.createdBy', this.note.createdBy)
      console.log('userId', this.userId)
      console.log('email', this.$store.getters["user/email"])
      console.log('familyName', this.$store.getters["user/familyName"])
      console.log('role', this.$store.getters["user/role"])
      

      const date = new Date(isoString)
      // Get the UTC time
      let utcTime = date.getTime();
      // Convert UTC to PST (UTC - 8 hours)
      let pstTime = new Date(utcTime - (7 * 60 * 60 * 1000));
      const time = pstTime.toLocaleString("en-US", {
        hour: "numeric",
        minute: "numeric",
        hour12: false
      })
      const month = date.toLocaleString("en-US", { month: "short" })
      const week = date.toLocaleString("en-US", { weekday: "short" })
      return `${week},${date.getDate()} ${month} ${date.getFullYear()} ${time}`
    }
  }
}

const reportCard = document.querySelector(".card")
const btnClose = document.querySelector(".btn-close")

console.log('btnShowReport', reportCard, btnClose)

if(btnClose !== null){
  btnClose.onmouseenter = () => {
  btnClose.classList.add("active")
  btnClose.innerHTML = "Close"
}

btnClose.onmouseleave = () => {
  btnClose.classList.remove("active");
  btnClose.innerHTML = "x";
}
btnClose.onclick = () => reportCard.classList.toggle("show")
}


</script>
<style lang="scss" scoped>
.comment-item {
  width: 100%;
  margin-bottom: 29px;
  // &__close {
  //   position: absolute;
  //   right: 69px;
  //   top: 11px;
  //   width: 32px;
  //   height: 32px;
  //   opacity: 0.3;
  //   padding: 1em;
  //   z-index: 1000;
  // }
  // &__close:hover {
  //   opacity: 1;
  // }
  // &__close:before {
  //   content: " ";
  //   position: absolute;
  //   left: 15px;
  //   top: 8px;
  //   height: 15px;
  //   width: 2px;
  //   background-color: #333;
  // }
  // &__close:after {
  //   content: " ";
  //   position: absolute;
  //   left: 15px;
  //   top: 8px;
  //   height: 15px;
  //   width: 2px;
  //   background-color: #333;
  // }
  // &__close:before {
  //   transform: rotate(45deg);
  // }
  // &__close:after {
  //   transform: rotate(-45deg);
  // }
  &__header {
    height: 100%;
    display: inline-block;
  }
  &__header-avarta {
    position: absolute;
    bottom: 30px;
  }
  &__float-left {
    float: right;
    display: flex;
    flex-direction: column;
    align-content: flex-end;
    align-items: end;
    align-self: end;
  }
  &__float-right {
    float: left;
    display: flex;
    flex-direction: column;
    align-content: start;
    align-items: start;
    align-self: start;
  }
  &__message {
    min-height: 65px;
    padding: 20px;
  }
  // &__message:hover > .btn-close {
  //   display: initial;
  //   transition: all 0.2s ease-out;
  // }
  // &__message:hover {
  //   // font-size: 38px;
  //   // position: absolute;
  //   // right: 69px;
  //   // top: 11px;
  //   // width: 32px;
  //   // height: 32px;
  //   // opacity: 0.3;
  //   // padding: 1em;
  //   z-index: 1000;
  // }
  // &__message:hover:before {
  //   content: " ";
  //   position: absolute;
  //   right: 13px;
  //   top: 3.5px;
  //   height: 15px;
  //   width: 3px;
  //   background-color: #fff;
  // }
  // &__message:hover:after {
  //   content: " ";
  //   position: absolute;
  //   right: 13px;
  //   top: 3.5px;
  //   height: 15px;
  //   width: 3px;
  //   background-color: #fff;
  // }
  // &__message:hover:before {
  //   transform: rotate(45deg);
  // }
  // &__message:hover:after {
  //   transform: rotate(-45deg);
  // }
  &__message-left {
    display: inline-block;
    background-color: #e5e5ea !important;
    color: black;
    padding: 12px 16px;
    font-size: 18px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif;
    border-radius: 20px;
    max-width: 60%;
    position: relative;
  }
  &__message-left::before {
    content: "";
    width: 20px;
    background-color: #e5e5ea;
    position: absolute;
    bottom: 0;
    height: 26px;
    left: -10px;
    border-left: 20px solid var(--sentColor);
    border-bottom-right-radius: 16px 14px;
    // transform: translateX(15px);
  }
  &__message-left::after {
    content: "";
    width: 20px;
    background-color: white;
    position: absolute;
    bottom: 0;
    height: 26px;
    left: -33.5px;
    border-left: 20px solid var(--sentColor);
    border-bottom-right-radius: 16px 14px;
    transform: translateX(13px);
  }
  &__message-right {
    display: inline-block;
    background-color: #007aff !important;
    color: white;
    padding: 12px 16px;
    font-size: 18px;
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", sans-serif;
    border-radius: 20px;
    max-width: 60%;
    position: relative;
  }
  &__message-right::before {
    content: "";
    width: 20px;
    background-color: #007aff;
    position: absolute;
    bottom: -1px;
    height: 26px;
    right: -10px;
    border-right: 20px solid var(--sentColor);
    border-bottom-left-radius: 16px 14px;
    // transform: translateX(15px);
  }
  &__message-right::after {
    content: "";
    width: 20px;
    background-color: white;
    position: absolute;
    bottom: 0;
    height: 26px;
    right: -6.6px;
    border-right: 20px solid var(--sentColor);
    border-bottom-left-radius: 16px 14px;
    transform: translateX(13px);
  }
  // &__message-left:hover ~ #closeButton {
  //   display: block;
  // }
  &__message-right ~ &__close-button {
    display: block;
    width: 2em;
    color: aqua;
    z-index: 10011;
    position: absolute;
    top: 13px;
    height: 2em;
    background: aquamarine;
    right: -10px;
    border-radius: 25px;
  }
  &__message-date {
    font-family: Proxima Nova;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 22px;
    letter-spacing: 0.13125px;
    color: #c4c4c4;
  }
  &__email_address {
    font-family: Proxima Nova;
    font-style: normal;
    font-weight: normal;
    font-size: 14px;
    line-height: 22px;
    letter-spacing: 0.13125px;
    color: #c4c4c4;
  }
}

// #message:hover + #closeButton {
//   display: block !important;
// }
// #message:hover {
//   background-color: aquamarine !important;
// }
// .comment-item__message:hover {
//   display: none !important;
//   background-color: aquamarine !important;
// }

.btn-close {
  position: absolute;
  top: -4px;
  right: -4px;
  border-radius: 50px;
  width: 20px;
  height: 20px;
  border: 1px solid silver;
  background: #a1a1a1;
  color: #fff;
  cursor: pointer;
  display: none;
  font-family: 'Proxima';
  line-height: normal;
  font-size: small;
}

#message:hover > .btn-close {
  display: initial;
  transition: all 0.2s ease-out;
}

.btn-close.active {
  border-radius: 5px;
  width: 50px;
  transform: translateX(5px);
}

</style>
